
export default function Title(props){
    // Small component that renders the title
    return (
        <>
            <h1>{props.attr}</h1>
        </>
    );
}